import { h, Component, Fragment, options } from 'preact';
import FilterComponent from '../components/filter.component';
import { config } from '../config/config';

export default class CountyFilterComponent extends Component {
    constructor() {
        super();
        this.state = {
            options: []
        };
    }

    changeDataType() {
        // console.log('%cTRACE: changeDataType', 'color: green; font-weight: 900; background: white')
        const dataType = this.props.selectedDataType;
        const geographyType = this.props.selectedGeographyType;
        // data type change update the available filter options and reset most selected filters
        let options = [];
        if (dataType && geographyType) {
            options = config.counties.filter(x => x[geographyType.id].includes(dataType.id));
            options = this.filterBySelectedStates(options);
        }

        this.setState({
            options
        });
    }

    componentDidUpdate(prevProps) {
        // console.log('%cTRACE: componentDidUpdate', 'color: green; font-weight: 900; background: white')
        // change when dataType, geographyType, or selected states are changed
        if (this.props.selectedDataType !== prevProps.selectedDataType ||
            this.props.selectedGeographyType !== prevProps.selectedGeographyType ||
            (
                this.props.selectedStates.length !== prevProps.selectedStates.length ||
                this.props.selectedStates.some(s => !prevProps.selectedStates.includes(s))
            )) {
            // only update this if the data types have changed
            this.changeDataType();
        }
    }

    filterBySelectedStates(options) {
        // console.log('%cTRACE: filterBySelectedStates', 'color: green; font-weight: 900; background: white')
        if (!this.props.selectedStates.length) {
            return options;
        }

        const selectedStateIds = {};
        this.props.selectedStates.forEach(state => {
            selectedStateIds[state.id] = 1;
        });

        // filter out any options that don't match a selected state, if there are any selected states
        return options.filter(county => !this.props.selectedStates.length || selectedStateIds[county.stateId]);
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <FilterComponent
                    options={self.state.options}
                    onSelect={(option) => self.props.toggleSelect(option)}
                    selected={self.props.selected}
                    message="Select Counties"
                    ga="QR Menu: County"
                />
            </Fragment>
        );
    }
}
